import React from 'react';
import './style.scss';
import Table from '../../Table';
import dropdownIcon from '../../../assets/icons/dropdown.svg'

function AccountsTable() {

    const columns = [
        { Header: 'Accounts', accessor: 'accounts' },
        { Header: <span>Start Date <img src={dropdownIcon} alt='' /></span>, accessor: 'startDate' },
        { Header: 'Stage', accessor: 'stage' },
        { Header: 'Status', accessor: 'status', Cell: ({ value }) => (
            <button className={`status-btn ${value.toLowerCase() === 'active' ? 'green-bg-btn' : 'red-bg-btn'}`}>{value}</button>
        )},
        { Header: 'Broker', accessor: 'broker' },
        { Header: 'Platform', accessor: 'platform' },
        { Header: 'Visible in Dropdown', accessor: 'visibleInDropdown' },
        { Header: 'Next Billing Date', accessor: 'nextBillingDate' },
        { Header: 'End Date', accessor: 'endDate' },
        { Header: 'Action', accessor: 'action' }
    ];

    const data = [
        {
            accounts: 'XYZ',
            startDate: <span>Mar 06 <i className="fas fa-info-circle"></i></span>,
            stage: 'Some Stage',
            status: 'Active',
            broker: 'Broker XYZ',
            platform: 'Platform ABC',
            visibleInDropdown: 'Yes',
            nextBillingDate: '2024-05-15',
            endDate: '2025-05-06',
            action: 'Approve',
        },
        {
            accounts: 'ABC',
            startDate: <span>Apr 01 <i className="fas fa-info-circle"></i></span>,
            stage: 'Another Stage',
            status: 'Inactive',
            broker: 'Broker ABC',
            platform: 'Platform XYZ',
            visibleInDropdown: 'No',
            nextBillingDate: '2024-05-20',
            endDate: '2025-04-30',
            action: 'Reject',
        },
        {
            accounts: 'XYZ',
            startDate: <span>Mar 06 <i className="fas fa-info-circle"></i></span>,
            stage: 'Some Stage',
            status: 'Active',
            broker: 'Broker XYZ',
            platform: 'Platform ABC',
            visibleInDropdown: 'Yes',
            nextBillingDate: '2024-05-15',
            endDate: '2025-05-06',
            action: 'Approve',
        },
        {
            accounts: 'XYZ',
            startDate: <span>Mar 06 <i className="fas fa-info-circle"></i></span>,
            stage: 'Some Stage',
            status: 'Active',
            broker: 'Broker XYZ',
            platform: 'Platform ABC',
            visibleInDropdown: 'Yes',
            nextBillingDate: '2024-05-15',
            endDate: '2025-05-06',
            action: 'Approve',
        },
        {
            accounts: 'XYZ',
            startDate: <span>Mar 06 <i className="fas fa-info-circle"></i></span>,
            stage: 'Some Stage',
            status: 'Active',
            broker: 'Broker XYZ',
            platform: 'Platform ABC',
            visibleInDropdown: 'Yes',
            nextBillingDate: '2024-05-15',
            endDate: '2025-05-06',
            action: 'Approve',
        },
        {
            accounts: 'XYZ',
            startDate: <span>Mar 06 <i className="fas fa-info-circle"></i></span>,
            stage: 'Some Stage',
            status: 'Active',
            broker: 'Broker XYZ',
            platform: 'Platform ABC',
            visibleInDropdown: 'Yes',
            nextBillingDate: '2024-05-15',
            endDate: '2025-05-06',
            action: 'Approve',
        },
        {
            accounts: 'XYZ',
            startDate: <span>Mar 06 <i className="fas fa-info-circle"></i></span>,
            stage: 'Some Stage',
            status: 'Active',
            broker: 'Broker XYZ',
            platform: 'Platform ABC',
            visibleInDropdown: 'Yes',
            nextBillingDate: '2024-05-15',
            endDate: '2025-05-06',
            action: 'Approve',
        },
        {
            accounts: 'XYZ',
            startDate: <span>Mar 06 <i className="fas fa-info-circle"></i></span>,
            stage: 'Some Stage',
            status: 'Active',
            broker: 'Broker XYZ',
            platform: 'Platform ABC',
            visibleInDropdown: 'Yes',
            nextBillingDate: '2024-05-15',
            endDate: '2025-05-06',
            action: 'Approve',
        },
        {
            accounts: 'XYZ',
            startDate: <span>Mar 06 <i className="fas fa-info-circle"></i></span>,
            stage: 'Some Stage',
            status: 'Active',
            broker: 'Broker XYZ',
            platform: 'Platform ABC',
            visibleInDropdown: 'Yes',
            nextBillingDate: '2024-05-15',
            endDate: '2025-05-06',
            action: 'Approve',
        },
        {
            accounts: 'XYZ',
            startDate: <span>Mar 06 <i className="fas fa-info-circle"></i></span>,
            stage: 'Some Stage',
            status: 'Active',
            broker: 'Broker XYZ',
            platform: 'Platform ABC',
            visibleInDropdown: 'Yes',
            nextBillingDate: '2024-05-15',
            endDate: '2025-05-06',
            action: 'Approve',
        },
        {
            accounts: 'XYZ',
            startDate: <span>Mar 06 <i className="fas fa-info-circle"></i></span>,
            stage: 'Some Stage',
            status: 'Active',
            broker: 'Broker XYZ',
            platform: 'Platform ABC',
            visibleInDropdown: 'Yes',
            nextBillingDate: '2024-05-15',
            endDate: '2025-05-06',
            action: 'Approve',
        },
        {
            accounts: 'XYZ',
            startDate: <span>Mar 06 <i className="fas fa-info-circle"></i></span>,
            stage: 'Some Stage',
            status: 'Active',
            broker: 'Broker XYZ',
            platform: 'Platform ABC',
            visibleInDropdown: 'Yes',
            nextBillingDate: '2024-05-15',
            endDate: '2025-05-06',
            action: 'Approve',
        },
        {
            accounts: 'XYZ',
            startDate: <span>Mar 06 <i className="fas fa-info-circle"></i></span>,
            stage: 'Some Stage',
            status: 'Active',
            broker: 'Broker XYZ',
            platform: 'Platform ABC',
            visibleInDropdown: 'Yes',
            nextBillingDate: '2024-05-15',
            endDate: '2025-05-06',
            action: 'Approve',
        },
        {
            accounts: 'XYZ',
            startDate: <span>Mar 06 <i className="fas fa-info-circle"></i></span>,
            stage: 'Some Stage',
            status: 'Active',
            broker: 'Broker XYZ',
            platform: 'Platform ABC',
            visibleInDropdown: 'Yes',
            nextBillingDate: '2024-05-15',
            endDate: '2025-05-06',
            action: 'Approve',
        },
        {
            accounts: 'XYZ',
            startDate: <span>Mar 06 <i className="fas fa-info-circle"></i></span>,
            stage: 'Some Stage',
            status: 'Active',
            broker: 'Broker XYZ',
            platform: 'Platform ABC',
            visibleInDropdown: 'Yes',
            nextBillingDate: '2024-05-15',
            endDate: '2025-05-06',
            action: 'Approve',
        },
    ];

    return (
        <div className='accounts-table'>
            <Table columns={columns} data={data} />
        </div>
    )
}

export default AccountsTable;
